import React from 'react'
import withStyles from 'material-ui-next/styles/withStyles'

const styles = theme => ({
  container: {
    marginTop: 10,
    position: 'absolute',
    right: 0,
    left: 0,
    padding: '1rem',
    backgroundColor: theme.swapick.colors.footergrey,
    textAlign: 'center',
    height: 50,
    paddingTop: 3,
    fontSize: '14px',
  },
  '@media (max-width: 576px)': {
    container: {
      fontSize: '10px',
      height: '40px',
    },
  },
})

const Footer = ({ classes }) => (
  <div className={classes.container}>
    <p>
      Copyright © 2020 swapick.com. Tutti i diritti sono riservati.
    </p>
  </div>
)

export default withStyles(styles)(Footer)



// WEBPACK FOOTER //
// ./src/common/Footer.js